<template>
  <div>
    <div class="loader" v-if="this.isLoading"></div>   
    <div class="loadertext" v-if="this.isLoading"> {{$t('loadingTxt')}}...</div>   
    <div class="main-wrapper" :class="{'blur-content': this.isLoading}">
        <!--begin::navbar-->
        <navbar-component></navbar-component>
        <!--end::navbar-->
 

      <div class="page-wrapper">

        <!--begin::content-->
        <div class="page-content">
          <div class="row">
            <div class="col-lg-12 col-xl-12 col-sm-12 col-xs-12 col-md-12">
              <div class="card">
                
                 <div class="card-header">
                  <!-- <i class="link-icon float-start" data-feather="arrow-left"></i> -->
                  &nbsp;&nbsp;&nbsp;
                  <h6 class="card-title mb-0 float-start" style="padding-left:25px">Detail Transaction | Load ID : {{ forms.load_id }}</h6>
                  
 

                </div>


                   
                    <div class="card-footer">
                      <button
                        class="
                          btn btn-info
                          text-black
                          fw-bolder
                          btn-icon-text
                        "
                        @click="backForm"
                        type="button"
                      >
                        <i class="mdi mdi-arrow-left"></i>
                        {{ $t("backMess") }}
                      </button>

                      <a
                        v-if="permision_role.method_delete && forms.status_code=='FAILED'"
                        class="
                          btn btn-danger
                          text-white
                          fw-bolder
                          btn-icon-text
                          float-end
                        "
                        @click="deleteData()"
                      >
                        <i class="mdi mdi-delete-forever"></i>
                        {{ $t("deleteMess") }}
                      </a>

                      <a
                        v-if="permision_role.method_update && forms.status_code=='WAITING_APPROVAL'"
                        class="
                          btn btn-primary
                          me-2
                          text-white
                          fw-bolder
                          btn-icon-text
                          float-end
                        "
                        @click="approveData()"
                      >
                        <i class="mdi mdi-thumb-up"></i>
                        Approve
                      </a>

                      <a
                        v-if="permision_role.method_update && forms.status_code=='WAITING_APPROVAL'"
                        class="
                          btn btn-warning
                          me-2
                          text-white
                          fw-bolder
                          btn-icon-text
                          float-end
                        "
                        @click="rejectData()"
                      >
                        <i class="mdi mdi-thumb-down"></i>
                        Reject
                      </a>

                       <a
                        v-if="permision_role.method_custom1 && forms.bank_id=='1' && forms.status_code=='FAILED'"
                        class="
                          btn btn-secondary
                          me-2
                          text-white
                          fw-bolder
                          btn-icon-text
                          float-end
                        "
                        @click="inqueryBca()"
                      >
                        <i class="mdi mdi-file-check"></i>
                        Inquery BCA
                      </a>


                       <a
                        v-if="permision_role.method_custom1 && forms.bank_id=='1' && forms.status_code=='NEW'"
                        class="
                          btn btn-primary
                          me-2
                          text-white
                          fw-bolder
                          btn-icon-text
                          float-end
                        "
                        @click="updateStatusBca('WAITING_APPROVAL')"
                      >
                        <i class="mdi mdi-file-check"></i>
                        Update Status To WAITING_APPROVAL
                      </a>

                       <a
                        v-if="permision_role.method_custom1 && forms.bank_id=='1' && forms.status_code=='NEW'"
                        class="
                          btn btn-secondary
                          me-2
                          text-white
                          fw-bolder
                          btn-icon-text
                          float-end
                        "
                        @click="updateStatusBca('APPROVED')"
                      >
                        <i class="mdi mdi-file-check"></i>
                        Update Status To Approved
                      </a>


                    </div>

                <div class="card-body">
              
  
                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">Type</label>
                      </div>
                      <div class="col-lg-8">
                        <input
                          type="text"
                          class="form-control"
                          id="type"
                          v-model="forms.type"
                          readonly
                        />
                       
                      </div>
                    </div>

 

                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label for="defaultconfig" class="col-form-label" style="padding-left: 25px"> Client Code </label>
                      </div>
                      <div class="col-lg-8">
                        <input
                          type="text"
                          class="form-control"
                          id="client_code"
                          v-model="client.client_code"
                          readonly
                        />
                        
                      </div>
                    </div>

 

                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label for="defaultconfig" class="col-form-label" style="padding-left: 25px"> Client Name </label>
                      </div>
                      <div class="col-lg-8">
                        <input
                          type="text"
                          class="form-control"
                          id="name"
                          v-model="client.name"
                          readonly
                        />
                        
                      </div>
                    </div>

                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">Load ID</label>
                      </div>
                      <div class="col-lg-8">
                        <input
                          type="text"
                          class="form-control"
                          id="load_id"
                          v-model="forms.load_id"
                          readonly
                        />
                       
                      </div>
                    </div>

  
                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">Location ID</label>
                      </div>
                      <div class="col-lg-8">
                        <input
                          type="text"
                          class="form-control"
                          id="location"
                          v-model="forms.location"
                          readonly
                        />
                       
                      </div>
                    </div>

  
                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">Driver Name</label>
                      </div>
                      <div class="col-lg-8">
                        <input
                          type="text"
                          class="form-control"
                          id="driver_name"
                          v-model="forms.driver_name"
                          readonly
                        />
                       
                      </div>
                    </div>

  
                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">Account Number</label>
                      </div>
                      <div class="col-lg-8">
                        <input
                          type="text"
                          class="form-control"
                          id="account_number"
                          v-model="forms.account_number"
                          readonly
                        />
                       
                      </div>
                    </div>
                    
  
                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">Total Amount</label>
                      </div>
                      <div class="col-lg-8">
                        <input
                          type="text"
                          class="form-control"
                          id="amount"
                          v-model="forms.amount"
                          readonly
                        />
                       
                      </div>
                    </div>
                    
  
                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">Approval By</label>
                      </div>
                      <div class="col-lg-8">
                        <input
                          type="text"
                          class="form-control"
                          id="approval_by"
                          v-model="forms.approval_by"
                          readonly
                        />
                       
                      </div>
                    </div>
                    
  
                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">Status</label>
                      </div>
                      <div class="col-lg-8">
                        <input
                          type="text"
                          class="form-control"
                          id="status_code"
                          v-model="forms.status_code"
                          readonly
                        />
                       
                      </div>
                    </div>
                    
                    
                    <div class="row mb-3">
 
                        <div class="example">

                            <div class="accordion" id="accordionExample">

                                <div v-for="(tracking, index) in this.forms.trackings" :key="index">
                                 
                                    <div class="card">
                                        <div class="card-body">
                                        <h5 class="card-title">{{tracking.status_code}}</h5> 
                            
                                      <pre>{{prettyJson(tracking.remarks)}}</pre> 
                                        <!-- <vue-code-highlight>
                                            <code>
                                            {{ tracking.remarks}}
                                            </code>
                                        </vue-code-highlight> -->

                                        <p class="card-link">{{tracking.created_at}}</p>
                                        </div>
                                    </div>

                                </div>


                            </div>

                        </div>

                         

                    </div>







                    

                </div>
              </div>
            </div>
          </div>
        </div>
        <!--end::content-->



          <!--begin::modal-->

            <modal name="inqueryBcaModal" :draggable="false" :scrollable="true" :height="'auto'">
                <div class="modal fade show " tabindex="-1" style="display: block;margin-top: 2%;" aria-modal="true" role="dialog">
                <div class="modal-dialog  modal-xl">
                    <div class="modal-content">
    
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">Response Inquery BCA</h5>
                        <button type="button" class="btn btn-default"  @click.prevent="removeModals()" aria-label="Close">
                          <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
    
                   
                      <div class="modal-body">

                        <div class="mb-3">

                            <label for="recipient-name" class="form-label">Datas</label>
                              
                            <pre>{{prettyJson(this.inqueryBcaData)}}</pre> 

                        </div>
                              

                      </div>
      
      
                      <div class="modal-footer justify-content-between">

                        <button type="button" class="btn btn-secondary" @click.prevent="removeModals()">{{this.$t("close_txt")}}</button>            
                        <button v-if="this.forms.status_code=='FAILED'" type="button" class="btn btn-danger" @click.prevent="resendDataBca()">Resend Data</button>            
                        <button v-if="this.forms.status_code=='FAILED' && this.inqueryBcaData.responseCode == '2003600'" type="button" class="btn btn-danger" @click.prevent="updateStatusBca('SUCCESS')">Update Status To Success</button>            
                        <!-- <button v-if="this.forms.status_code=='SUCCESS' && this.inqueryBcaData.responseCode == '4043601'" type="button" class="btn btn-danger" @click.prevent="updateStatusBca('FAILED')">Update Status To Success</button>             -->

                      </div>
     
    
                    </div>
                </div>
                </div>
            </modal>

          <!--end::modal-->

        <!--begin::footer-->
        <footer-component></footer-component>
        <!--end::footer-->
      </div>
    </div>
  </div>
</template>
  
  
<script>
import navbarComponent from "@/components/_partials/_navbar";
import footerComponent from "@/components/_partials/_footer";
// import { component as VueCodeHighlight } from 'vue-code-highlight';

export default {
  name: "BlujayBcaTransactionDetail",
  props: {},
  components: {
    "navbar-component": navbarComponent,
    "footer-component": footerComponent,
    //  VueCodeHighlight
 
  },
  data() { 

    return {
        client:{},
      digit: {
        decimal: ',',
        thousands: '.',
        prefix: ' ',
        suffix: '',
        precision: 5,
        masked: false
      },
      fetchStockCondition: [],
      detailAsn: [],
      orderType: '',
      fetchOrderType: [],
      shelfLifeUnit: {},
      shelfLifeType: {},
      permision_role: [],
      isLoading: false,
      maxToasts: 100,
      position: "up right",
      closeBtn: true,
      errors: [],
      userData: "",
      userRole: "",
      companyCode: "",
      fetchStatus: ['ACTIVE', 'DEACTIVE'],
      fetchmultiWhFlag: ['Y', 'N'],
      fetchCustomer: [],
      fetchFulfillment: [],
      customer: "",
      fulfillment: "",
      fetchShelfLifeType: [],
      fetchShelfLifeUnit: [],
      fetchSku: [],
      activeFlag: false,
      shelfLifeFlag: false,
      kitFlag: false,
      freePickGift: false,
      isLoadingStatus: false,
      forms: {},
      inqueryBcaData: {responseCode:"" , responseMessage:"", originalReferenceNo:"",  originalPartnerReferenceNo:"",  originalExternalId:"",  serviceCode:"",  transactionDate:"", amount:{value:"" , currency:""}, beneficiaryAccountNo:"", beneficiaryBankCode:"", referenceNumber:"", sourceAccountNo:"", latestTransactionStatus:"", transactionStatusDesc:"" },

    };
  },
  watch: {},
    methods: {

        prettyJson(value){
          
            if(value){

              var str = '';
              
               try {
                  str = JSON.stringify(JSON.parse(value), null, 2);
              } catch (e) {
                  str = value;
              }

                return str;
            }else{
              return value;
            }
            
        },

        rejectData() {
           
            let inputValue = ""
            this.$swal.fire({
                title: this.$t("yourRemarks") + ' Reject',
                input: "text",
                inputValue,
                showCancelButton: true,
                inputValidator: (value) => {
                    if (!value) {
                    return "You need to write something!";
                    }else{
                        
                        var params = this.$onBehind(this.$route.params.id);

                        var bank_transaction_id = params[0];

                        var forms = {
                            approval_status:"REJECTED",
                            remarks:value
                        };

                        const baseURI =  this.$settings.endPointBlujayBca + "v2/bank-transaction/approval/" + bank_transaction_id;
                        this.$http.post(baseURI, forms , { timeout: 10000 })
                            .then((response) => {
                                this.loading();
                                if (response.data.status === 200) {
                                this.success(response.data.datas.messages);
                                this.loadData(bank_transaction_id);
                                } else {
                                this.errors = response.data.errors;
                                this.resultError(response.data.errors);
                                }
                            }).catch((error) => {
                                this.loading();
                
                                if (error.code == "ECONNABORTED") {
                                this.error(this.$t("check_internet_connection_txt"));
                
                                } else {
                
                
                                if (error.code == "ECONNABORTED") {
                                    this.error(this.$t("check_internet_connection_txt"));
                
                                } else {
                
                                    if (error.response) {
                                    if (error.response.status === 422) {
                                        this.errors = error.response.data.errors;
                                        this.resultError(error.response.data.errors);
                                    } else if (error.response.status === 401) {
                                        this.logout();
                                    } else if (error.response.status === 403) {
                                        this.$router.push("/authorized-error");
                                    } else if (error.response.status === 500) {
                                        this.$router.push('/server-error');
                                    } else {
                                        this.$router.push('/page-not-found');
                                    }
                                    }
                
                                }
                
                                }
                            });


                    }
                }
            });
             
        },

        approveData() {
            
            this.$swal({
            title: this.$t("areYouSure"),
            text: this.$t("yourDataApprove"),
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes!",
            }).then((result) => {
            if (result.value) {
                
                var params = this.$onBehind(this.$route.params.id);

                var bank_transaction_id = params[0];

                var forms = {
                    approval_status:"APPROVED"
                };

                const baseURI =  this.$settings.endPointBlujayBca + "v2/bank-transaction/approval/" + bank_transaction_id;
                this.$http
                .post(baseURI, forms , { timeout: 10000 })
                .then((response) => {
                    this.loading();
                    if (response.data.status === 200) {
                    this.success(response.data.datas.messages);
                    this.loadData(bank_transaction_id);
                   
                    } else {
                    this.errors = response.data.errors;
                    this.resultError(response.data.errors);
                    }
                }).catch((error) => {
                    this.loading();
    
                    if (error.code == "ECONNABORTED") {
                    this.error(this.$t("check_internet_connection_txt"));
    
                    } else {
    
    
                    if (error.code == "ECONNABORTED") {
                        this.error(this.$t("check_internet_connection_txt"));
    
                    } else {
    
                        if (error.response) {
                        if (error.response.status === 422) {
                            this.errors = error.response.data.errors;
                            this.resultError(error.response.data.errors);
                        } else if (error.response.status === 401) {
                            this.logout();
                        } else if (error.response.status === 403) {
                            this.$router.push("/authorized-error");
                        } else if (error.response.status === 500) {
                            this.$router.push('/server-error');
                        } else {
                            this.$router.push('/page-not-found');
                        }
                        }
    
                    }
    
                    }
                });
            } else {
                this.isLoading = false;
            }
            });
        },

        deleteData() {
            
            this.$swal({
            title: this.$t("areYouSure"),
            text: this.$t("yourDataDelete"),
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes!",
            }).then((result) => {
            if (result.value) {


                var params = this.$onBehind(this.$route.params.id);

                var bank_transaction_id = params[0];
        
                const baseURI =  this.$settings.endPointBlujayBca + "v2/bank-transaction/delete/" + bank_transaction_id;
                this.$http
                .delete(baseURI, { timeout: 10000 })
                .then((response) => {
                    this.loading();
                    if (response.data.status === 200) {
                    this.success(response.data.datas.messages);
                    this.backForm();
                    } else {
                    this.errors = response.data.errors;
                    this.resultError(response.data.errors);
                    }
                }).catch((error) => {
                    this.loading();

                    if (error.code == "ECONNABORTED") {
                    this.error(this.$t("check_internet_connection_txt"));

                    } else {


                    if (error.code == "ECONNABORTED") {
                        this.error(this.$t("check_internet_connection_txt"));

                    } else {

                        if (error.response) {
                        if (error.response.status === 422) {
                            this.errors = error.response.data.errors;
                            this.resultError(error.response.data.errors);
                        } else if (error.response.status === 401) {
                            this.logout();
                        } else if (error.response.status === 403) {
                            this.$router.push("/authorized-error");
                        } else if (error.response.status === 500) {
                            this.$router.push('/server-error');
                        } else {
                            this.$router.push('/page-not-found');
                        }
                        }

                    }

                    }
                });
            } else {
                this.isLoading = false;
            }
            });
        },


    
      toCurrency (value) {
          if (typeof value !== "number") {
              return value;
          }
          var formatter = new Intl.NumberFormat('en-US', {
              style: 'currency',
              currency: 'IDR'
          });
          return formatter.format(value);
      },


    loadData(id) {
            
        this.isLoading = true;
        const baseURI = this.$settings.endPointBlujayBca + "v2/bank-transaction/detail/" + id;

        return this.$http.get(baseURI, { timeout: 10000 }).then((response) => {

            this.isLoading      = false;
            this.forms          = response.data.datas;
            this.forms.amount   = this.toCurrency(response.data.datas.amount)
            this.client         = response.data.datas.client
        }).catch(error => {

            this.loading();

            if (error.code == "ECONNABORTED") {
            this.error(this.$t("check_internet_connection_txt"));
            } else {

            if (error.response) {
                if (error.response.status === 422) {
                this.errors = error.response.data.errors;
                this.resultError(error.response.data.errors);
                } else if (error.response.status === 401) {
                this.logout();
                } else if (error.response.status === 403) {
                this.$router.push("/authorized-error");
                } else if (error.response.status === 500) {
                this.$router.push('/server-error');
                } else {
                this.$router.push('/page-not-found');
                }
            }

            }

        });

    },

    cekData(index, fieldType) {
      console.log(index);
      console.log(fieldType);
      fieldType[index].skuDescr1 = fieldType[index].sku.skuDescr1;
      
    },
 

    fetchIt() {
      const userDatas = this.$getUserInfo();
      this.userData = userDatas.sub;
      this.userRole = userDatas.sub.role;
      let rolePermision = [];
      userDatas.sub.permision_role.forEach(function (permision) {
        if (permision.permission.controller == 'BankTransactionsController') {
          rolePermision = permision;
        }
      });

      if (!rolePermision.method_read) {
        this.$router.push("/authorized-error");
      }

      this.permision_role = rolePermision;

 

    },

    backForm() {
      window.location.href = "/blujay-bca/transactions";
    },
 

    logout() {

      const baseURI = this.$settings.endPoint + "user/logout";
      this.$http.get(baseURI, { timeout: 10000 }).then((response) => {

        console.log(response);

      });

      this.$logoutUser();
      window.location.href = '/';
    },

    fade(sType) {
      this.isLoading = sType;
    },

    loading() {
      this.fade(true);
      setTimeout(() => {
        this.fade(false);
      }, 1000); // hide the message after 3 seconds
    },

    resultError(data) {
      var count = Object.keys(data).length;
      for (var x = 0; x < count; x++) {
        var nameOb = Object.keys(data)[x];
        var objectData = data[nameOb];
        for (var y = 0; y < objectData.length; y++) {
          this.error(objectData[y]);
        }
      }
    },

    success(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "success",
        title: kata,
      });
    },

    error(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "error",
        title: kata,
      });
    },



        inqueryBca() {

          this.isLoading          = true;
          this.inqueryBcaData     = {responseCode:"" , responseMessage:"", originalReferenceNo:"",  originalPartnerReferenceNo:"",  originalExternalId:"",  serviceCode:"",  transactionDate:"", amount:{value:"" , currency:""}, beneficiaryAccountNo:"", beneficiaryBankCode:"", referenceNumber:"", sourceAccountNo:"", latestTransactionStatus:"", transactionStatusDesc:"" };
          var params              = this.$onBehind(this.$route.params.id);
          var bank_transaction_id = params[0];
          const baseURI           =  this.$settings.endPointBlujayBca + "v2/bank-transaction/inquery-bca/" + bank_transaction_id;
          this.$http.get(baseURI, { timeout: 10000 }).then((response) => {

              this.isLoading      = false;
              this.inqueryBcaData = response.data.datas;
              this.inqueryBcaModalFunction();

          }).catch(error => {

              this.loading();

              if (error.code == "ECONNABORTED") {
              this.error(this.$t("check_internet_connection_txt"));
              } else {

              if (error.response) {
                  if (error.response.status === 422) {
                  this.errors = error.response.data.errors;
                  this.resultError(error.response.data);
                  } else if (error.response.status === 401) {
                  this.logout();
                  } else if (error.response.status === 403) {
                  this.$router.push("/authorized-error");
                  } else if (error.response.status === 500) {
                  this.$router.push('/server-error');
                  } else {
                  this.$router.push('/page-not-found');
                  }
              }

              }

          });

        },


        removeModals() {
          
            this.$modal.hide('inqueryBcaModal')
            this.errors                 = []
    
        },


        inqueryBcaModalFunction() {
          
            this.$modal.show('inqueryBcaModal')
            this.errors                     = []

        },


        updateStatusBca(status_code) {
            
            this.$swal({
            title: this.$t("areYouSure"),
            text: "Update Status To " + status_code,
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes!",
            }).then((result) => {
            if (result.value) {
                
                var params = this.$onBehind(this.$route.params.id);

                var bank_transaction_id = params[0];

                var forms = {
                    status:status_code
                };

                const baseURI =  this.$settings.endPointBlujayBca + "v2/bank-transaction/change-status/" + bank_transaction_id;
                this.$http
                .patch(baseURI, forms , { timeout: 10000 }).then((response) => {

                    this.loading();
                    if (response.data.status === 200) {
                      this.success(response.data.datas.messages);
                      this.loadData(bank_transaction_id);
                   
                    } else {
                      this.errors = response.data.errors;
                      this.resultError(response.data.errors);
                    }
                }).catch((error) => {
                    this.loading();
    
                    if (error.code == "ECONNABORTED") {
                    this.error(this.$t("check_internet_connection_txt"));
    
                    } else {
    
    
                    if (error.code == "ECONNABORTED") {
                        this.error(this.$t("check_internet_connection_txt"));
    
                    } else {
    
                        if (error.response) {
                          if (error.response.status === 422) {
                              this.errors = error.response.data.errors;
                              this.resultError(error.response.data.errors);
                          } else if (error.response.status === 401) {
                              this.logout();
                          } else if (error.response.status === 403) {
                              this.$router.push("/authorized-error");
                          } else if (error.response.status === 500) {
                              this.$router.push('/server-error');
                          } else {
                              this.$router.push('/page-not-found');
                          }
                        }
    
                    }
    
                    }
                });
            } else {
                this.isLoading = false;
            }
            });
        },
        
        resendDataBca() {
            
            this.$swal({
            title: this.$t("areYouSure"),
            text: "Resend Data",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes!",
            }).then((result) => {
            if (result.value) {
                
                var params = this.$onBehind(this.$route.params.id);

                var bank_transaction_id = params[0];
 

                const baseURI =  this.$settings.endPointBlujayBca + "v2/bank-transaction/resend-data/" + bank_transaction_id;
                this.$http.get(baseURI , { timeout: 10000 }).then((response) => {

                    this.loading();
                    if (response.data.status === 200) {
                      
                      this.success(response.data.datas.messages);
                      this.loadData(bank_transaction_id);
                      this.$modal.hide('inqueryBcaModal')
                   
                    } else {
                      this.errors = response.data.errors;
                      this.resultError(response.data.errors);
                    }
                }).catch((error) => {
                    this.loading();
    
                    if (error.code == "ECONNABORTED") {
                    this.error(this.$t("check_internet_connection_txt"));
    
                    } else {
    
    
                    if (error.code == "ECONNABORTED") {
                        this.error(this.$t("check_internet_connection_txt"));
    
                    } else {
    
                        if (error.response) {
                          if (error.response.status === 422) {
                              this.errors = error.response.data.errors;
                              this.resultError(error.response.data.errors);
                          } else if (error.response.status === 401) {
                              this.logout();
                          } else if (error.response.status === 403) {
                              this.$router.push("/authorized-error");
                          } else if (error.response.status === 500) {
                              this.$router.push('/server-error');
                          } else {
                              this.$router.push('/page-not-found');
                          }
                        }
    
                    }
    
                    }
                });
            } else {
                this.isLoading = false;
            }
            });
        },

  },
  events: {},
  created: function () { },
  mounted() {
    this.fetchIt();

    var params = this.$onBehind(this.$route.params.id);

    this.loadData(params[0]);


  },
};
</script>
<style scoped>.required:after {
  content: " *";
  color: red;
}</style>